module.exports = __webpack_public_path__ + "assets/img/logo_mobile.f04889bb.png";